<ng-container *ngIf="modalData">
  <section #modal class="protection-details-upsell-modal">
    <div [ngSwitch]="modalData.prepaySubscriptionVariant">
      <ng-container *ngIf="modalData.registeredItemHasAnnualPayment">
        <ng-container *ngSwitchCase="prepaySubscriptionVariant.One">
          <h1 class="protection-details-upsell-modal__title">
            {{ 'PROTECTION_DETAILS_MODAL_TITLE_LAST_CHANCE' | translate }}
          </h1>
        </ng-container>

        <ng-container *ngSwitchCase="prepaySubscriptionVariant.Two">
          <h1 class="protection-details-upsell-modal__title">
            {{ 'PROTECTION_DETAILS_MODAL_TITLE_ANNUAL' | translate }}
          </h1>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <!-- Control variant -->
        <h1 class="protection-details-upsell-modal__title">
          <ng-container
            *ngIf="modalData.promotionalPriceEnabled; else promotionInactive"
          >
            {{
              'PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE_MODAL' | translate : {
                discountedMonthPercentage:
                  modalData.registeredItemProductDetails?.discountDetails
                    ?.discountedMonthPercentage,
              }
            }}
          </ng-container>
          <ng-template #promotionInactive>
            {{
              modalData.cmsProtectionDetailsUpsellModal
                .protectionDetailsModalTitle
            }}
          </ng-template>
        </h1>
      </ng-container>
    </div>

    <dgx-components-rich-text
      [content]="
        modalData.cmsProtectionDetailsUpsellModal.protectionDetailsModalSubtitle
      "
      class="protection-details-upsell-modal__subtitle py-5"
    />

    <dgx-components-panel
      [border]="false"
      [rounded]="'lg'"
      [spacing]="'md'"
      [variant]="'background-alternative'"
    >
      <h2 class="protection-details-upsell-modal__benefits-list-title pb-5">
        {{
          modalData.cmsProtectionDetailsUpsellModal
            .protectionDetailsModalBenefitsListTitle
        }}
      </h2>

      <dgx-components-benefits-list
        [benefits]="benefits"
        [iconSize]="'sm'"
        [theme]="'background-alternative'"
        class="protection-details-upsell-modal__benefits-list"
      />
    </dgx-components-panel>

    <div [ngSwitch]="modalData.prepaySubscriptionVariant">
      <ng-container *ngIf="modalData.registeredItemHasAnnualPayment">
        <ng-container *ngSwitchCase="prepaySubscriptionVariant.One">
          <ng-container *ngIf="modalData.promotionalPriceEnabled">
            <p class="protection-details-upsell-modal__quote-offer mt-6">
              {{
                'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
                  | translate
                    : {
                        brandName: modalData.merchandiseBrand
                      }
              }}
              <span
                class="protection-details-upsell-modal__price-strikethrough pr-1"
              >
                {{
                  modalData.registeredItemAnnualProductDetails?.price
                    | currencyFormat
                }}
              </span>
              {{
                modalData.registeredItemAnnualProductDetails?.discountDetails
                  ?.discountedPrice | currencyFormat
              }}
              for 12 months
            </p>

            <p
              class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
            >
              {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
            </p>
          </ng-container>

          <ng-container *ngIf="!modalData.promotionalPriceEnabled">
            <p class="protection-details-upsell-modal__quote-offer mt-6">
              {{
                'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
                  | translate
                    : {
                        brandName: modalData.merchandiseBrand
                      }
              }}
              {{
                modalData.registeredItemAnnualProductDetails?.price
                  | currencyFormat
              }}
              for 12 months
            </p>

            <p
              class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
            >
              {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
            </p>
          </ng-container>

          <dgx-components-grid-row class="pt-4">
            <dgx-components-grid-column
              *ngFor="let item of modalData.registeredItemProducts"
              [md]="6"
              class="protection-details-upsell-modal__purchase-price-option-column"
            >
              <us-registration-protection-details-purchase-price-option
                (buttonClicked)="handleModalPaymentOptionAction($event)"
                [badgeText]="
                  item.paymentFrequency === 'monthly'
                    ? ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY'
                      | translate
                        : {
                            discountedMonthPercentage:
                              item.discountDetails?.discountedMonthPercentage,
                            discountedMonthsCount:
                              item.discountDetails?.discountedMonthsCount
                          })
                    : ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY'
                      | translate
                        : {
                            discountedMonthPercentage:
                              item.discountDetails?.discountedMonthPercentage,
                            discountedMonthsCount:
                              item.discountDetails?.discountedMonthsCount
                          })
                "
                [buttonText]="
                  'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA'
                    | translate
                      : {
                          monthlyOrAnnual:
                            item | registeredItemMonthlyOrAnnuallyLabel
                        }
                "
                [discountedPrice]="
                  item.discountDetails?.discountedPrice | currencyFormat
                "
                [newMessage]="'PROTECTION_DETAILS_NEW_MESSAGE' | translate"
                [originalPrice]="item.price | currencyFormat"
                [paymentFrequency]="item.paymentFrequency"
                [promotionalPriceEnabled]="modalData.promotionalPriceEnabled"
              />
            </dgx-components-grid-column>
          </dgx-components-grid-row>

          <div class="protection-details-upsell-modal__reg-only-container pt-2">
            <dgx-components-button-text
              (clicked)="continueWithRegistrationOnly()"
              [dgxGaClick]="{
                pagename: 'protection-details-upsell-popup',
                eventCategory: 'modalUpsell',
                eventAction: 'modal-clicked',
                eventLabel: 'No thanks'
              }"
              [underline]="true"
              [underlineNeutral]="true"
            >
              {{ 'PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA' | translate }}
            </dgx-components-button-text>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="prepaySubscriptionVariant.Two">
          <ng-container *ngIf="modalData.promotionalPriceEnabled">
            <dgx-components-badge
              [spacing]="1"
              [theme]="'decoration-3'"
              class="protection-details-upsell-modal__promotional-badge mt-6"
            >
              <div
                class="protection-details-upsell-modal__promotional-badge-content"
              >
                <p
                  class="protection-details-upsell-modal__promotional-badge-content-title"
                >
                  {{
                    'PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUAL_PAYMENT'
                      | translate
                        : {
                            discountedMonthPercentage:
                              modalData.registeredItemAnnualProductDetails
                                ?.discountDetails?.discountedMonthPercentage,
                            discountedMonthsCount:
                              modalData.registeredItemAnnualProductDetails
                                ?.discountDetails?.discountedMonthsCount
                          }
                  }}
                </p>
                <dgx-components-icon [name]="'gift'" [size]="'sm'" />
              </div>
            </dgx-components-badge>

            <p class="protection-details-upsell-modal__quote-offer mt-6">
              {{
                'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
                  | translate
                    : {
                        brandName: modalData.merchandiseBrand
                      }
              }}
              <span
                class="protection-details-upsell-modal__price-strikethrough pr-1"
              >
                {{
                  modalData.registeredItemAnnualProductDetails?.price
                    | currencyFormat
                }}
              </span>
              {{
                modalData.registeredItemAnnualProductDetails?.discountDetails
                  ?.discountedPrice | currencyFormat
              }}
              for 12 months
            </p>

            <p
              class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
            >
              {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
            </p>
          </ng-container>

          <ng-container *ngIf="!modalData.promotionalPriceEnabled">
            <p class="protection-details-upsell-modal__quote-offer mt-6">
              {{
                'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
                  | translate
                    : {
                        brandName: modalData.merchandiseBrand
                      }
              }}
              {{
                modalData.registeredItemAnnualProductDetails?.price
                  | currencyFormat
              }}
              for 12 months
            </p>

            <p
              class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
            >
              {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
            </p>
          </ng-container>

          <div
            class="protection-details-upsell-modal__ctas-container--full-width pt-2"
          >
            <div class="protection-details-upsell-modal__ctas--full-width">
              <dgx-components-button
                (clicked)="continueWithExtraProtection(true)"
                [dgxGaClick]="{
                  pagename: 'protection-details-upsell-popup',
                  eventCategory: 'modalUpsell',
                  eventAction: 'modal-clicked',
                  eventLabel: 'Register with extra coverage'
                }"
                [fill]="true"
                [variant]="'primary'"
                class="protection-details-upsell-modal__cta my-4"
              >
                {{
                  'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA'
                    | translate
                      : {
                          monthlyOrAnnual:
                            modalData.registeredItemAnnualProductDetails
                            | registeredItemMonthlyOrAnnuallyLabel
                        }
                }}
              </dgx-components-button>

              <dgx-components-button
                (clicked)="continueWithRegistrationOnly()"
                [dgxGaClick]="{
                  pagename: 'protection-details-upsell-popup',
                  eventCategory: 'modalUpsell',
                  eventAction: 'modal-clicked',
                  eventLabel: 'No thanks'
                }"
                [fill]="true"
                [variant]="'secondary'"
                class="protection-details-upsell-modal__cta"
              >
                <span class="protection-details-upsell-modal__cta-no-extend">
                  {{
                    'PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON'
                      | translate
                  }}
                </span>
              </dgx-components-button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <!-- Control variant -->
        <p
          *ngIf="modalData.promotionalPriceEnabled"
          class="protection-details-upsell-modal__do-not-miss-out pt-5"
        >
          {{ 'PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE' | translate : {
            discountedMonthPercentage:
              modalData.registeredItemProductDetails?.discountDetails
                ?.discountedMonthPercentage,
            discountedMonthsCount:
              modalData.registeredItemProductDetails?.discountDetails
                ?.discountedMonthsCount,
          } }}
        </p>

        <p
          *ngIf="modalData.promotionalPriceEnabled"
          class="protection-details-upsell-modal__quote-offer mt-3"
        >
          {{
            'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
              | translate
                : {
                    brandName: modalData.merchandiseBrand
                  }
          }}
          for
          <span
            class="protection-details-upsell-modal__price-strikethrough pr-1"
            >{{
              modalData.registeredItemProductDetails?.price | currencyFormat
            }}
          </span>
          <span>{{
            modalData.registeredItemProductDetails?.price
              | quoteOfferPriceDiscounted : 0.5
              | currencyFormat
          }}</span>
          a month
        </p>

        <p
          *ngIf="!modalData.promotionalPriceEnabled"
          class="protection-details-upsell-modal__quote-offer mt-6"
        >
          {{
            'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
              | translate
                : {
                    brandName: modalData.merchandiseBrand
                  }
          }}
          {{
            'PROTECTION_DETAILS_QUOTE_OFFER_PRICE'
              | translate
                : {
                    quotePayment:
                      modalData.registeredItemProductDetails?.price
                      | currencyFormat
                  }
          }}
        </p>

        <p class="text--center">
          {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY' | translate }}
        </p>

        <div class="protection-details-upsell-modal__ctas-container pt-2">
          <div class="protection-details-upsell-modal__ctas">
            <dgx-components-button
              (clicked)="continueWithExtraProtection()"
              [dgxGaClick]="{
                pagename: 'protection-details-upsell-popup',
                eventCategory: 'modalUpsell',
                eventAction: 'modal-clicked',
                eventLabel: 'Register with extra coverage'
              }"
              [fill]="true"
              [variant]="'primary'"
              class="my-4"
            >
              <span class="protection-details-upsell-modal__cta-extend">
                {{
                  'PROTECTION_ADDITIONAL_QUOTE_MODAL_EXTEND_BUTTON' | translate
                }}
              </span>
            </dgx-components-button>

            <dgx-components-button
              (clicked)="continueWithRegistrationOnly()"
              [dgxGaClick]="{
                pagename: 'protection-details-upsell-popup',
                eventCategory: 'modalUpsell',
                eventAction: 'modal-clicked',
                eventLabel: 'No thanks'
              }"
              [fill]="true"
              [variant]="'secondary'"
            >
              <span class="protection-details-upsell-modal__cta-no-extend">
                {{
                  'PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON'
                    | translate
                }}
              </span>
            </dgx-components-button>
          </div>
        </div>
      </ng-container>
    </div>
  </section>
</ng-container>

<dgx-components-loading-overlay
  *ngIf="ctaUpsellLoading"
  [loader]="ctaUpsellLoading"
/>
